import Resource from '@/api/resources/Resource'

class IncidentsTypesConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/incidentTypes`, filterModel, { params })
        return response.data
    }
    async getTypesById(params) {
        const response = await this.axios.get(`/configuration/incidentTypes/${params.id}`, { params })
        return response.data
    }
    async patchTypesBatch(types) {
        const response = await this.axios.patch(`/configuration/incidentTypes/batch`, types)
        return response.data
    }
    async createType(type) {
        const response = await this.axios.post(`/configuration/incidentTypes`, type)
        return response.data
    }
    async deleteTypesBatch(types) {
        const data = {
            entityIdentifiers: types
        }
        const response = await this.axios.delete(`/configuration/incidentTypes/batch`, { data: data })
        return response.data
    }
}

export default new IncidentsTypesConfigurationServices()
